import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles, categories } from '@/mocks/articles';

function getCategoryJsonLd(slug: string, categoryName: string) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `http://818tp.cn/category/${slug}#webpage`,
        url: `http://818tp.cn/category/${slug}`,
        name: `${categoryName} - 吃瓜51网`,
        description: `吃瓜51网${categoryName}分类，每日更新最新${categoryName}爆料`,
        isPartOf: { '@id': 'http://818tp.cn/#website' },
        breadcrumb: { '@id': `http://818tp.cn/category/${slug}#breadcrumb` },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `http://818tp.cn/category/${slug}#breadcrumb`,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://818tp.cn/' },
          { '@type': 'ListItem', position: 2, name: categoryName },
        ],
      },
    ],
  };
}

const cardImageUrls: Record<string, string> = {
  'article-001': 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20livestream%20studio%20scene%20with%20glowing%20smartphone%20screens%20and%20neon%20ring%20lights%2C%20abstract%20modern%20Chinese%20internet%20entertainment%20photography%2C%20lime%20green%20accent%20lighting%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20high%20contrast%20shadows%2C%20no%20visible%20faces%2C%20artistic%20technology%20composition%20with%20warm%20dark%20tones&width=800&height=600&seq=cat-card-article-001&orientation=landscape',
  'article-002': 'https://readdy.ai/api/search-image?query=Blurry%20paparazzi%20style%20tropical%20beach%20sunset%20with%20palm%20trees%20and%20ocean%20waves%2C%20warm%20golden%20hour%20light%2C%20mysterious%20romantic%20atmosphere%2C%20artistic%20film%20grain%20texture%2C%20editorial%20photography%20aesthetic%2C%20soft%20focus%20dreamy%20quality%2C%20abstract%20figures%2C%20warm%20neutral%20tones&width=800&height=600&seq=cat-card-article-002&orientation=landscape',
  'article-003': 'https://readdy.ai/api/search-image?query=Dramatic%20still%20life%20of%20broken%20cosmetics%20and%20packaging%20on%20dark%20surface%2C%20harsh%20spotlight%20shadows%2C%20lime%20green%20warning%20accents%2C%20editorial%20product%20photography%2C%20investigative%20journalism%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20high%20detail%20closeups%2C%20clean%20white%20background%20contrast&width=800&height=600&seq=cat-card-article-003&orientation=landscape',
  'article-004': 'https://readdy.ai/api/search-image?query=Split%20composition%20of%20two%20contrasting%20modern%20elegant%20apartments%2C%20warm%20cool%20lighting%20duality%2C%20subtle%20storytelling%20interior%20design%2C%20cinematic%20framing%2C%20artistic%20editorial%20photography%2C%20sophisticated%20mood%2C%20separation%20theme%2C%20neutral%20warm%20tones&width=800&height=600&seq=cat-card-article-004&orientation=landscape',
  'article-005': 'https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20academic%20certificates%20and%20stage%20spotlights%20overlapping%20in%20dark%20space%2C%20dramatic%20contrast%20scholarship%20and%20entertainment%2C%20lime%20green%20accent%20lighting%2C%20modern%20Chinese%20variety%20show%20aesthetic%2C%20editorial%20photography%2C%20mysterious%20investigative%20atmosphere&width=800&height=600&seq=cat-card-article-005&orientation=landscape',
  'article-006': 'https://readdy.ai/api/search-image?query=Dramatic%20outdoor%20film%20production%20set%20with%20professional%20lighting%20and%20rigging%20against%20moody%20evening%20sky%2C%20subtle%20emergency%20lights%20in%20distance%2C%20cinematic%20composition%2C%20news%20journalism%20style%2C%20tense%20urgent%20atmosphere%2C%20warm%20neutral%20tones%2C%20environmental%20storytelling&width=800&height=600&seq=cat-card-article-006&orientation=landscape',
  'article-007': 'https://readdy.ai/api/search-image?query=Abstract%20split%20screen%20of%20two%20contrasting%20smartphone%20screens%20with%20glowing%20social%20media%20in%20dark%20space%2C%20dramatic%20lime%20green%20warm%20amber%20light%20division%2C%20digital%20conflict%20aesthetic%2C%20modern%20internet%20culture%20photography%2C%20high%20contrast%20editorial%20style%2C%20clean%20dark%20background%20neon%20accents&width=800&height=600&seq=cat-card-article-007&orientation=landscape',
  'article-008': 'https://readdy.ai/api/search-image?query=Dark%20cinema%20auditorium%20interior%20with%20single%20spotlight%20on%20empty%20director%20chair%2C%20dramatic%20shadow%20play%20across%20theater%20seats%2C%20mysterious%20tense%20atmosphere%2C%20film%20industry%20aesthetic%2C%20editorial%20investigative%20photography%2C%20lime%20green%20rim%20light%20creating%20intrigue%2C%20cinematic%20noir%20style&width=800&height=600&seq=cat-card-article-008&orientation=landscape',
  'article-009': 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20scene%20with%20dramatic%20spotlights%20and%20camera%20flash%20effects%2C%20glamorous%20sophisticated%20atmosphere%2C%20fashion%20photography%20aesthetic%2C%20warm%20gold%20champagne%20tones%2C%20luxury%20event%20styling%2C%20editorial%20photography%2C%20soft%20ambient%20light%2C%20clean%20elegant%20background&width=800&height=600&seq=cat-card-article-009&orientation=landscape',
};

const categoryHeroImages: Record<string, string> = {
  'wanghong-tafang': 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20of%20crumbling%20social%20media%20icons%20and%20shattered%20screens%2C%20neon%20lime%20green%20accent%20lighting%2C%20digital%20collapse%20and%20scandal%20aesthetic%2C%20modern%20Chinese%20internet%20culture%20photography%2C%20moody%20mysterious%20atmosphere%2C%20editorial%20style%2C%20high%20contrast%2C%20warm%20dark%20tones&width=1800&height=900&seq=cat-hero-wanghong&orientation=landscape',
  'mingxing-bagua': 'https://readdy.ai/api/search-image?query=Glamorous%20abstract%20composition%20of%20camera%20flashes%20and%20paparazzi%20silhouettes%20in%20dark%20space%2C%20warm%20gold%20and%20champagne%20tones%20with%20lime%20green%20accent%2C%20celebrity%20culture%20aesthetic%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20mysterious%20elegant%20mood%2C%20high%20contrast&width=1800&height=900&seq=cat-hero-mingxing&orientation=landscape',
  'remen-shijian': 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20of%20trending%20fire%20symbols%20and%20digital%20data%20streams%20in%20dark%20space%2C%20vibrant%20lime%20green%20and%20warm%20amber%20accents%2C%20viral%20content%20energy%2C%20modern%20social%20media%20aesthetic%2C%20editorial%20photography%20style%2C%20high%20energy%20dramatic%20atmosphere%2C%20exciting%20mood&width=1800&height=900&seq=cat-hero-remen&orientation=landscape',
  'dujia-baoliao': 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20composition%20of%20confidential%20documents%20and%20magnifying%20glass%20silhouettes%20in%20dark%20space%2C%20lime%20green%20accent%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20secretive%20spy%20theme%20atmosphere%2C%20editorial%20photography%20style%2C%20dramatic%20shadows%2C%20intriguing%20mood&width=1800&height=900&seq=cat-hero-dujia&orientation=landscape',
  'shishi-zhuizong': 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20of%20radar%20screens%20and%20tracking%20lines%20in%20dark%20space%2C%20neon%20lime%20green%20scanning%20patterns%2C%20real-time%20monitoring%20aesthetic%2C%20modern%20surveillance%20technology%20theme%2C%20editorial%20photography%20style%2C%20high%20tech%20mysterious%20atmosphere%2C%20continuous%20motion%20feeling&width=1800&height=900&seq=cat-hero-shishi&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-[60vh] flex items-center justify-center pt-20">
          <div className="text-center">
            <h1 className="font-heading font-black text-2xl text-foreground-950 mb-2">分类不存在</h1>
            <Link to="/" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const filteredCategoryArticles = articles.filter((a) => a.categorySlug === slug);
  const categoryArticles = filteredCategoryArticles.length ? filteredCategoryArticles : articles;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getCategoryJsonLd(slug, category.name)) }}
      />
      <Navbar />
      <main>
        <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center overflow-hidden" aria-labelledby="category-heading">
          <div className="absolute inset-0">
            <img
              src={categoryHeroImages[slug] || categoryHeroImages['remen-shijian']}
              alt=""
              className="w-full h-full object-cover object-top"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-16">
                <div className="lg:w-1/2">
                  <nav className="flex items-center gap-2 text-xs font-label text-background-50/60 mb-4" aria-label="面包屑导航">
                    <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <span className="text-accent-400">{category.name}</span>
                  </nav>
                  <h1 id="category-heading" className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight tracking-tight">
                    {category.name}
                  </h1>
                </div>
                <div className="lg:w-1/2">
                  <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-4">
                    {category.description}
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-sm font-label font-bold text-accent-400 hover:text-accent-300 transition-colors group cursor-pointer"
                  >
                    返回首页
                    <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-[5]"></div>
        </section>

        <section className="py-14 md:py-20 bg-background-50" aria-label={`${category.name}文章列表`}>
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex items-center justify-between mb-10">
              <div>
                <p className="text-xs font-label font-medium text-foreground-400 uppercase tracking-widest mb-1">
                  {category.name}
                </p>
                <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
                  共 <span className="text-accent-500">{categoryArticles.length}</span> 篇爆料
                </h2>
              </div>
              <div className="hidden sm:flex items-center gap-2">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className={`px-3 py-1.5 text-xs font-label font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                      c.slug === slug
                        ? 'bg-accent-500 text-foreground-950'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {categoryArticles.map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group block cursor-pointer"
                  >
                    <article className="flex flex-col h-full" data-product-shop>
                      <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden mb-4">
                        {index === 1 ? (
                          <div className="w-full h-full bg-primary-500 flex flex-col items-center justify-center p-8 text-center">
                            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center mb-4">
                              <i className={`${category.icon} text-4xl md:text-5xl text-accent-500`}></i>
                            </div>
                            <p className="font-heading font-black text-lg md:text-xl text-background-50 leading-snug line-clamp-2">
                              {article.title}
                            </p>
                          </div>
                        ) : (
                          <>
                            <img
                              src={cardImageUrls[article.id] || cardImageUrls['article-001']}
                              alt={article.title}
                              title={`${article.title} - 吃瓜51网`}
                              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                              loading={index < 3 ? 'eager' : 'lazy'}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          </>
                        )}
                        {article.isExclusive && index !== 1 && (
                          <span className="absolute top-3 left-3 px-2.5 py-1 text-[10px] font-label font-bold bg-accent-500 text-foreground-950 rounded-md whitespace-nowrap">
                            独家
                          </span>
                        )}
                      </div>

                      {index !== 1 && (
                        <>
                          <span className="inline-block px-3 py-1 text-[11px] font-label font-bold bg-accent-100 text-accent-800 rounded-md mb-2 whitespace-nowrap">
                            {article.category}
                          </span>
                          <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                            {article.title}
                          </h3>
                        </>
                      )}

                      <div className="flex items-center gap-3 mt-auto pt-2">
                        <span className="text-xs text-foreground-500 font-label">{article.date}</span>
                        <span className="text-xs text-foreground-400 font-label">
                          {(article.readCount / 10000).toFixed(1)}万阅读
                        </span>
                      </div>
                    </article>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}